module.exports = "https://static.zego.com/_next/static/images/Prize-c34b86cd622a9961286394178309de4d.svg";